import './polyfills';
import main from '../main';

main();
